export default "/images/arrowUp.svg?7ad43e910593a35b978560360be1b0f6";